import { Overlay, OverlayContainer } from '@angular/cdk/overlay';
import { ScrollDispatcher as CdkScrollDispatcher } from '@angular/cdk/scrolling';
import { Optional, Provider, SkipSelf } from '@angular/core';

import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { filterBoolean } from '@recruitee/common';
import { ScrollDispatcher } from '@recruitee/user-interface';

import { ScrollStream$ } from './consts';
import {
  ContextTooltipOverlay,
  ContextTooltipOverlayContainer,
} from './directives/context-tooltip-container.directive';

export const OVERLAY_PROVIDERS: Provider[] = [
  {
    provide: ContextTooltipOverlay,
    useFactory: (overlay: Overlay, contextOverlay?: ContextTooltipOverlay) =>
      contextOverlay || overlay,
    deps: [Overlay, [SkipSelf, Optional, ContextTooltipOverlay]],
  },
  {
    provide: ContextTooltipOverlayContainer,
    useFactory: (
      overlayContainer: OverlayContainer,
      contextContainer?: ContextTooltipOverlayContainer,
    ) => contextContainer || overlayContainer,
    deps: [OverlayContainer, [SkipSelf, Optional, ContextTooltipOverlayContainer]],
  },
];

export const SCROLL_PROVIDER: Provider = {
  provide: ScrollStream$,
  useFactory: (
    cdkScrollDispatcher?: CdkScrollDispatcher,
    rtScrollDispatcher?: ScrollDispatcher,
  ) => {
    if (!cdkScrollDispatcher && !rtScrollDispatcher)
      throw new Error('You need to provide scroll dispatcher');
    const AUDIT_TIME: number | undefined = undefined;

    if (rtScrollDispatcher) {
      return new Observable<void>(observer =>
        rtScrollDispatcher.scrolled(AUDIT_TIME, () => observer.next()),
      );
    } else {
      return cdkScrollDispatcher!.scrolled(AUDIT_TIME).pipe(
        filterBoolean,
        switchMap(scroll => scroll.elementScrolled()),
      );
    }
  },
  deps: [
    [Optional, CdkScrollDispatcher],
    [Optional, ScrollDispatcher],
  ],
};
